<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div
      id="swiper"
      class="container-fuild whiteBackGround"
    >
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item,index) in bannerList"
            :key="index"
            @click="toLink(item.link)"
          >
            <picture>
              <!-- pc端 -->
              <source
                media="(min-width: 997px)"
                :srcset="item.image"
              >
              <!-- 移动端 -->
              <source
                media="(max-width: 996px)"
                :srcset="item.image2"
              >
              <img :src="item.image">
            </picture>
            <!-- <div class="swiper-lazy-preloader"></div> -->
            <div class="swiper-slide-title">
              <!-- <h1>{{item.title}}</h1> -->
              <!-- <p>{{item.content}}</p> -->
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div> -->
        <!-- <div class="swiper-button-next"></div> -->
      </div>
    </div>
    <!-- 主要服务 -->
    <div
      id="mainService"
      class="container-fuild"
      v-if="businessList.length > 0"
    >
      <div class="container">
        <div>
          <p class="mainService-title text-center">
            <!-- 主要服务 -->
          </p>
          <div class="underline">
            <div class="underline-red">
              <!-- 下划线样式，勿删 -->
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-lg-3 col-md-3 col-sm-3 col-xs-12"
            style="margin-top: 16px;"
            v-for="(item,index) in businessList"
            :key="index"
          >
            <div class="mainServerImgBox">
              <img
                :src="item.img"
                alt=""
                class="img-responsive center-block"
                @click="navigateToMainServe(item)"
              >
              <div
                class="imgMask"
                style=""
              >
                <span>{{item.title}}</span>
              </div>
            </div>
            <!-- <p class="text-center" style="margin-top: 5px;cursor: pointer;" @click="navigateToMainServe(item)">{{item.title}}</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻中心 -->
    <div
      id="newsBox"
      class="container-fuild whiteBackGround"
      v-if="noticeList.length > 0 || newsList.length > 0"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-5 col-xs-12"
            style="margin-top: 12px;"
          >
            <div class="borderBox">
              <div class="new_box_top">
                <div class="new_box_top_title">通知公告</div>
                <div
                  class="new_box_top_more"
                  @click="goArticleListPage(13)"
                >更多 ></div>
              </div>
              <div class="scrollBox">
                <div
                  class="new_box_msgData"
                  v-for="(item,index) in noticeList"
                  :key="index"
                >
                  <div
                    class="new_box_msgData_top"
                    @click="toArticlePage(item.id)"
                  >
                    <div class="tag">[{{item.tag}}]</div>
                    <a
                      class="newTitle"
                      :title="item.title"
                    >{{item.title}}</a>
                  </div>
                  <div class="new_box_msgData_msg">
                    <p class="newMsg">{{item.digest}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-7 col-xs-12"
            style="margin-top: 12px;"
          >
            <div class="borderBox">
              <div class="new_box_top">
                <div class="new_box_top_title">业界新闻</div>
                <div
                  class="new_box_top_more"
                  @click="goArticleListPage(14)"
                >更多 ></div>
              </div>
              <div class="scrollBox">
                <div
                  class="new_box_msgData"
                  v-for="(item,index) in newsList"
                  :key="index"
                  @click="toArticlePage(item.id)"
                >
                  <div class="new_box_msgData_top">
                    <div class="tag_right">[{{item.tag}}]</div>
                    <a
                      class="newTitle_right"
                      style="width: 100%;"
                      :title="item.title"
                    >{{item.title}}</a>
                    <div style="white-space: nowrap;">{{timestampToTime(item.createTime)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div
      id="customer"
      class="container-fuild whiteBackGround"
    >
      <div class="container">
        <div>
          <p class="customer-title text-center">{{ $t("message.i18n_17") }}</p>
          <div class="underline">
            <div class="underline-red">
              <!-- 下划线样式，勿删 -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
            <div style="border-bottom: 1px solid #dadada;line-height: 60px;">
              <span style="font-size: 16px;color: #000;">{{companyInfo.title}}</span>
            </div>
            <div style="color: #555;margin-top: 20px;line-height: 30px;font-weight: 300;">
              {{companyInfo.digest}}
              <div
                class="learnMore"
                @click="toSinglepage"
              >{{ $t("message.i18n_18") }}</div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6  video wow slideInUp">
            <!-- 正式放开 -->
            <video
              controls="controls"
              class="img-responsive"
              style="width: 100%;height: 300px;"
            >
              <source src="../assets/img/gbVideo.mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <div
      id="linkListBox"
      class="conatiner-fuild whiteBackGround"
    >
      <div class="container">
        <div class="linkListBox-title text-center">
          <div class="underline">
            <div class="underline-red">
              <!-- 下划线样式，勿删 -->
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-xs-6 col-sm-6 col-md-2 server-wrapper"
            v-for="(item,index) in linkList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#666';this.style.borderColor='#ccc';this.style.background='#ffffff';this.style.opacity='0.8'"
              onmouseleave="this.style.color='#666';this.style.borderColor='#ccc';this.style.background='none';this.style.opacity=1"
              style="cursor:pointer;border-radius: 8px;"
              @click="toLink(item.link)"
            >
              <img
                class="center-block"
                :src="item.image"
                alt="logo"
              >
              <!-- <p class="text-center">{{item.title}}</p> -->
              <!-- <div
                class="text-center"
                v-html="item.content"
                onmouseenter="this.style.color='#28f'"
                onmouseleave="this.style.color='#ccc'"
              ></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import {
  WOW
} from 'wowjs';
import {
  GetHomeData
} from '../api/api.js'
export default {
  name: "HomePage",
  data () {
    return {
      linkList: [],
      bannerList: [
        // {
        //   "image": "https://imgcdnwww.gongbocoins.com/202411051528/1475996db0956dd5f1b795a85e9a63c2/other%2F437778af0f48436388871d72dbafeeb4.jpeg",
        //   "image2": "https://imgcdnwww.gongbocoins.com/202411051528/1475996db0956dd5f1b795a85e9a63c2/other%2F437778af0f48436388871d72dbafeeb4.jpeg",
        //   "link": "",
        //   "title": "图片公告",
        //   "titleEnglish": null
        // },
        // {
        //   "image": "https://imgcdnwww.gongbocoins.com/202411051528/1762e6758c9dc8e15148bee1e29d3c26/other%2F324ba21dfce745dc9e3d14b01991648b.jpeg",
        //   "image2": "https://imgcdnwww.gongbocoins.com/202411051528/1762e6758c9dc8e15148bee1e29d3c26/other%2F324ba21dfce745dc9e3d14b01991648b.jpeg",
        //   "link": "",
        //   "title": "图片公告",
        //   "titleEnglish": null
        // },
        // {
        //   "image": "https://imgcdnwww.gongbocoins.com/202411051528/f4f581a11c6fc7e4eeb1390d87e311dc/other%2Fe642c56416284affbdf012b3beacbfcf.jpeg",
        //   "image2": "https://imgcdnwww.gongbocoins.com/202411051528/f4f581a11c6fc7e4eeb1390d87e311dc/other%2Fe642c56416284affbdf012b3beacbfcf.jpeg",
        //   "link": "",
        //   "title": "图片公告",
        //   "titleEnglish": null
        // },
        // {
        //   "image": "https://imgcdnwww.gongbocoins.com/202411051528/f1478ad54751f0e3da4a6f4f11fb9f80/other%2F14c3bd1bfb914833b271f0181a184c18.jpeg",
        //   "image2":"https://imgcdnwww.gongbocoins.com/202411051528/f1478ad54751f0e3da4a6f4f11fb9f80/other%2F14c3bd1bfb914833b271f0181a184c18.jpeg",
        //   "link": "",
        //   "title": "图片公告",
        //   "titleEnglish": null
        // },
        // {
        //   "image": "https://imgcdnwww.gongbocoins.com/202411051528/3c36238a5b65d3d2533129a3c868949b/other%2F3ccde3476e66474c91b6915584fb3658.jpeg",
        //   "image2": "https://imgcdnwww.gongbocoins.com/202411051528/3c36238a5b65d3d2533129a3c868949b/other%2F3ccde3476e66474c91b6915584fb3658.jpeg",
        //   "link": "",
        //   "title": "图片公告",
        //   "titleEnglish": null
        // },

      ],
      companyInfo: [],
      businessList: [],
      noticeList: [],
      newsList: []
    };
  },
  mounted () {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      autoHeight: true, // 自动调整高度
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: false
    })
    wow.init();
    this.getHomeData()
  },
  methods: {
    toArticlePage (id) {
      this.$router.push({
        path: '/page/article/' + id,
      })
    },
    goArticleListPage (id) {
      this.$router.push({
        path: '/page/article_list/' + id,
      })
    },
    timestampToTime (timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    navigateToMainServe (item) {
      this.$bus.$emit('mainServer', true)
      if (item.type == 0) {
        // 链接
        window.open(item.url)
      } else if (item.type == 1) {
        // 单页
        this.$router.push({
          path: '/page/singlepage/' + item.id,
        })
      } else if (item.type == 2) {
        // 文章
      } else if (item.type == 3) {
        // 图片
        return false
      }
    },
    toLink (url) {
      if (url) {
        window.open(url)
      }
    },
    toSinglepage () {
      this.$router.push({
        path: '/page/singlepage/1',
      })
    },
    getHomeData () {
      GetHomeData().then(res => {
        if (res && res.errorCode == 0) {
          this.linkList = res.data.linkList
          this.bannerList = res.data.bannerList
          this.companyInfo = res.data.companyInfo
          this.businessList = res.data.businessList
          this.noticeList = res.data.noticeList
          this.newsList = res.data.newsList
          // console.log(this.bannerList,'this.bannerList')
        } else {

        }
      })
    },
  }
};
</script>
<style scoped>
	/* 背景色 - 白色 */
	.whiteBackGround {
		background-color: white;
	}
	
	/* 整体盒子 */
	#HomePage {
		width: 100%;
		background-image: url(../../static/home_bg.jpg);
		background-color: no-repeat;
		/* 固定背景图片位置 */
		background-attachment:fixed;
	}

	/* 轮播图 */
	#swiper {
		/* height: 475px; */
	}

	#swiper .banner-swiper {
		width: 100%;
		height: 100%;
	}

	#swiper .banner-swiper .swiper-slide img {
		width: 100%;
		height: 100%;
	}

	#swiper .banner-swiper .swiper-slide {
		position: relative;
	}

	#swiper .banner-swiper .swiper-slide-title {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 999999999;
		width: 100%;
		height: 100%;
		color: #fff;
		/* background: rgba(51, 51, 51, 0.534); */
		text-align: center;
		line-height: 80px;
	}

	#swiper .banner-swiper .swiper-slide-title>h1 {
		font-size: 50px;
		margin-top: 12%;
	}

	#swiper .banner-swiper .swiper-slide-title>p {
		font-size: 20px;
		margin-top: 1%;
		font-weight: 700;
	}
	
	/* 新闻中心 */
	#newsBox {
		box-sizing: border-box;
		/* background: #efefef; */
		transition: all ease 0.6s;
	}
	
	#newsBox .borderBox {
		padding: 20px;
		height: 445px;
		border: 2px solid #eee;
		border-top: 2px solid #E22434;
	}
	
	#newsBox .borderBox .new_box_top {
		display: flex;
		justify-content: space-between;
		width: 100%;
		border-bottom: 2px solid #eee;
	}
	
	#newsBox .borderBox .scrollBox {
		overflow-y: scroll;
		height: 370px;
		-ms-overflow-style: none;  /* IE*/
		overflow: -moz-scrollbars-none; /* FireFox */
		scrollbar-width: none; /* firefox */
	}
	
	#newsBox .borderBox .scrollBox::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	
	#newsBox .borderBox .new_box_msgData {
		margin-top: 20px;
	}
	
	#newsBox .borderBox .new_box_msgData_top {
		cursor: pointer;
		display: flex;
	}
	
	#newsBox .borderBox .new_box_msgData_top .tag {
		margin-right: 5px;
		white-space: nowrap;
		color: #D61E36;
		font-weight: bold;
	}
	
	#newsBox .borderBox .new_box_msgData_top .tag_right {
		margin-right: 5px;
		white-space: nowrap;
		color: #D61E36;
	}
	
	#newsBox .borderBox .new_box_msgData_top .newTitle_right {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		color: #333;
		text-decoration: none;
	}
	
	#newsBox .borderBox .new_box_msgData_top .newTitle_right:hover {
		color: #D61E36;
	}
	
	#newsBox .borderBox .new_box_msgData_top .newTitle {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		color: #333;
		font-weight: bold;
		text-decoration: none;
	}
	
	#newsBox .borderBox .new_box_msgData_top .newTitle:hover {
		color: #D61E36;
	}
	
	#newsBox .borderBox .new_box_msgData_msg {
		
	}
	
	#newsBox .borderBox .new_box_msgData_msg .newMsg {
		margin-top: 8px;
		color: #555;
		line-height: 20px;
	}
	
	#newsBox .borderBox .new_box_top .new_box_top_title {
		margin-bottom: 8px;
		font-size: 22px;
		color: #E22434;
		font-weight: bold;
	}
	
	#newsBox .borderBox .new_box_top .new_box_top_more {
		font-size: 16px;
		color: #23527c;
		cursor: pointer;
	}
	
	/* 主营服务 */
	#mainService {
		padding: 50px 0;
		box-sizing: border-box;
		/* background: #efefef; */
		transition: all ease 0.6s;
	}
	
	#mainService .mainService-title {
		font-size: 38px;
		color: #333;
		font-weight: bold;
		margin: 0 0 30px;
	}
	
	#mainService .underline {
		border-bottom: 3px solid #ebebeb;
		width: 50%;
		margin-left: 25%;
		margin-top: -26px;
		position: relative;
	}
	
	#mainService .underline-red {
		border-bottom: 3px solid #E22434;
		width: 30%;
		margin-left: 25%;
		position: absolute;
		left: 10%;
		top: 0;
	}
	
	.mainServerImgBox {
		position: relative;
		cursor: pointer;
		overflow: hidden;
	}
	
	.mainServerImgBox .imgMask {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.3);
	}
	
	.mainServerImgBox .imgMask span {
		color: #fff;
		font-weight: bold;
		font-size: 20px
	}
	
	.mainServerImgBox:hover .imgMask {
		display: none;
	}
	
	.mainServerImgBox img {
		transition: 1s all;
	}
	
	.mainServerImgBox:hover img {
		transform: scale(1.2);
	}
	
	/* 关于我们 */
	#customer {
		padding: 50px 0;
		box-sizing: border-box;
		/* background: #efefef; */
		transition: all ease 0.6s;
	}

	#customer .video {
		margin-top: 30px;
	}

	#customer .underline {
		border-bottom: 3px solid #ebebeb;
		width: 50%;
		margin-left: 25%;
		margin-top: -26px;
		position: relative;
	}

	#customer .underline-red {
		border-bottom: 3px solid #E22434;
		width: 30%;
		margin-left: 25%;
		position: absolute;
		left: 10%;
		top: 0;
	}

	#customer .customer-title {
		font-size: 38px;
		color: #333;
		font-weight: bold;
		margin: 0 0 30px;
	}

	#customer .customer-logo img {
		width: 94px;
		height: 94px;
		border: 1px solid #ccc;
	}

	#customer .customer-yh img {
		width: 34px;
		height: 34px;
	}

	#customer .customer-content1 {
		padding-bottom: 20px;
		border-bottom: 1px solid #0ce9f1;
	}

	#customer .customer-content2 {
		padding-top: 20px;
	}

	/* 为什么选择我们 */
	#linkListBox {
		padding: 100px;
	}

	#linkListBox .underline {
		border-bottom: 3px solid #ebebeb;
		width: 50%;
		margin-left: 25%;
		margin-top: -26px;
		position: relative;
	}

	#linkListBox .underline-red {
		border-bottom: 3px solid #E22434;
		width: 30%;
		margin-left: 25%;
		position: absolute;
		left: 10%;
		top: 0;
	}

	#linkListBox .linkListBox-title {
		margin-bottom: 50px;
	}

	#linkListBox .linkListBox-title p:nth-of-type(1) {
		font-size: 25px;
		font-weight: 500;
	}

	#linkListBox .linkListBox-title p:nth-of-type(2) {
		font-size: 14px;
	}

	#linkListBox .server-block {
		/* padding: 50px 20px; */
		margin-top: 10px;
		/* border-bottom: 5px solid #ccc; */
	}

	#linkListBox .server-block img {
		border-radius: 5px;
		border: 1px solid #ccc;
		width: 160px;
		height: 70px;
	}

	#linkListBox .server-block>p {
		font-size: 20px;
		margin: 30px 0;
	}

	#linkListBox .server-block>div {
		color: #ccc;
	}

	.learnMore {
		background-color: #E22434;
		width: 140px;
		color: #fff;
		text-align: center;
		border-radius: 15px;
		margin-top: 20px;
		cursor: pointer;
	}

	/* 媒体查询（手机） */
	@media screen and (max-width: 768px) {

		#swiper {
			/* height: 200px; */
		}

		#customer {
			padding: 30px 0;
			box-sizing: border-box;
			/* background: #fff; */
		}

		#customer .customer-title {
			font-size: 16px;
			font-weight: bold;
		}

		#customer .customer-logo img {
			width: 48px;
			height: 48px;
		}

		#linkListBox {
			padding: 20px 0;
			transition: all ease 0.6s;
		}

		#linkListBox .linkListBox-title p:nth-of-type(1) {
			font-size: 20px;
			font-weight: 700;
		}

		#linkListBox .linkListBox-title p:nth-of-type(2) {
			font-size: 12px;
		}

		#linkListBox .server-block {
			/* padding: 50px 0; */
			margin-top: 10px;
			/* border: 1px solid #ccc; */
			/* border-bottom: 5px solid #ccc; */
		}

		#linkListBox .server-block img {
			width: 160px;
			height: 70px;
			border-radius: 5px;
			border: 1px solid #ccc;
		}

		#linkListBox .server-block>p {
			font-size: 20px;
			margin: 30px 0;
		}

		#linkListBox .server-block>div {
			color: #ccc;
		}
	}

	/* 媒体查询（平板） */
	@media screen and (min-width: 768px) and (max-width: 996px) {
		#swiper {
			/* height: 400px; */
		}

		#customer .customer-title {
			font-size: 24px;
		}

		#linkListBox {
			padding: 20px 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue